<button
        class="btn btn-up"
        [ngClass]="{'slide-in': windowIsScrolled}"
        (click)="scrollToTop()">
    <span class="library-bekb-icon-font icon-pfeil-oben white"></span>
</button>
